export default __webpack_public_path__ + "static/media/ic-chevron-down.cd1bb5a5.svg";